import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import PageHeader from '../../components/shell/PageHeader';

const TABS = [
    { to: '/quality', label: 'Panoramica', icon: 'bi-grid-1x2', end: true },
    { to: '/quality/issues', label: 'Problemi', icon: 'bi-exclamation-diamond', end: false },
    { to: '/quality/reports', label: 'Segnalazioni', icon: 'bi-flag', end: false },
    { to: '/quality/events', label: 'Eventi grezzi', icon: 'bi-activity', end: false },
    { to: '/quality/remediation', label: 'Remediation IA', icon: 'bi-stars', end: false },
] as const;

const QualityCenterLayout: React.FC = () => (
    <>
        <PageHeader
            title="Quality Center"
            description="Un solo punto di triage per anomalie tecniche, segnalazioni utenti e correzioni assistite."
            actions={
                <span className="small text-body-secondary d-flex align-items-center gap-2">
                    <span className="quality-live-dot" aria-hidden="true" />
                    Raccolta eventi attiva
                </span>
            }
        />

        <nav className="nav nav-tabs quality-tabs mb-3" aria-label="Sezioni Quality Center">
            {TABS.map(item => (
                <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.end}
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                    <i className={`bi ${item.icon} me-2`} />
                    {item.label}
                </NavLink>
            ))}
        </nav>

        <Outlet />
    </>
);

export default QualityCenterLayout;
